import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { APIResponseModel } from '@models/common.model';
import { UserConfig } from '@models/user-config.model';
import { UserConfigService } from '@services/user-config.service';

/**
 * Resolver that loads user config (whitelabeling) before the main app shell renders.
 * Ensures logo, verifier URL, and theme are available before any protected route activates.
 */
export const UserConfigResolver: ResolveFn<
  APIResponseModel<UserConfig>
> = () => {
  const userConfigService = inject(UserConfigService);
  return userConfigService.loadConfig();
};
